import React from "react";
import ModalFormUI from "../../../widgets/form/ModalFormUI";
import InputTextSF from "../../../widgets/form/InputTextSF";
import InputSelectSF from "../../../widgets/form/InputSelectSF";
const SecurityDepositAddModalUI = ({
	context, successMsg, errorList, setErrorList,
	createMode, onSubmit, submitted, onCancelCreate,
	depositAmount, onDepositAmountChange, depositAmountError, setDepositAmountError,
}) =>
	<ModalFormUI
		context={context}
		titleLabel='Add Security Deposit'
		buttonLabel='Add'
		cancelLabel='Cancel'
		isOpen={createMode}
		onRequestClose={onCancelCreate}
		successMsg={successMsg}
		errorList={errorList}
		setErrorList={setErrorList}
		onSubmit={onSubmit}
		busy={submitted}
	>
		<div className='col'>
			<InputTextSF type='price' name='depositAmount'
				label='Deposit Amount'
				value={depositAmount} onChange={onDepositAmountChange}
				error={depositAmountError} setError={setDepositAmountError}
			/>
		</div>
	</ModalFormUI>
export default SecurityDepositAddModalUI;